<script>
import { generateTimeSeriesData } from "./reporting-mock-data";
import toCurrency from "@/helpers/currency";
import moment from "moment";

export default {
  name: "reporting-timeseries-chart",
  props: {
    periodType: {
      type: String,
      default: "month",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeSeriesData: [],
      chartOptions: {
        chart: {
          type: "area",
          height: 350,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        colors: ["#556ee6", "#34c38f"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.1,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: -45,
            rotateAlways: false,
          },
        },
        yaxis: [
          {
            title: {
              text: "Revenue",
            },
            labels: {
              formatter: (value) => toCurrency(value),
            },
          },
          {
            opposite: true,
            title: {
              text: "Quantity",
            },
            labels: {
              formatter: (value) => Math.round(value).toLocaleString(),
            },
          },
        ],
        tooltip: {
          shared: true,
          intersect: false,
          y: [
            {
              formatter: (value) => toCurrency(value),
            },
            {
              formatter: (value) =>
                Math.round(value).toLocaleString() + " units",
            },
          ],
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
        },
        grid: {
          borderColor: "#f1f1f1",
        },
      },
      series: [],
    };
  },
  watch: {
    periodType: {
      handler: "loadData",
      immediate: true,
    },
  },
  methods: {
    loadData() {
      // Simulate API call with mock data
      this.timeSeriesData = generateTimeSeriesData(this.periodType);
      this.updateChart();
    },
    updateChart() {
      // Prepare categories (x-axis labels)
      const categories = this.timeSeriesData.map((item) =>
        this.formatPeriodLabel(item.period)
      );

      // Prepare series data
      const revenueData = this.timeSeriesData.map(
        (item) => Math.round(item.revenue * 100) / 100
      );
      const quantityData = this.timeSeriesData.map((item) =>
        Math.round(item.quantity)
      );

      // Update chart
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: categories,
        },
      };

      this.series = [
        {
          name: "Revenue",
          type: "area",
          data: revenueData,
        },
        {
          name: "Quantity",
          type: "line",
          data: quantityData,
        },
      ];
    },
    formatPeriodLabel(period) {
      switch (this.periodType) {
        case "week":
          return period; // Format: YYYY-WWW
        case "month":
          return moment(period, "YYYY-MM").format("MMM YYYY");
        case "year":
          return period;
        default:
          return period;
      }
    },
  },
};
</script>

<template>
  <b-card no-body>
    <b-card-body>
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="card-title mb-0">Revenue & Quantity Trend</h4>
        <div>
          <i class="bx bx-trending-up text-primary font-size-20"></i>
        </div>
      </div>

      <div v-if="isLoading" class="text-center py-5">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
        <p class="text-muted mt-2">Loading chart data...</p>
      </div>

      <div v-else>
        <apexchart
          type="area"
          height="350"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </b-card-body>
  </b-card>
</template>

<style scoped>
.card-title {
  font-size: 1.1rem;
  font-weight: 600;
}
</style>
